import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
const HeaderTiles = { id: 5, name: 'Header Tiles' };
export const chatIconVisibility = defineFeature({
    type: FeatureType.Boolean,
    propName: 'chat_icon_visibility',
    uiName: 'chatIconVisibility',
    displayName: 'Chat Icon',
    description: 'Toggles the display the Chat icon in the header',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const supportIcon = defineFeature({
    type: FeatureType.String,
    propName: 'support_icon',
    uiName: 'supportIcon',
    displayName: 'Support',
    description: 'Support email address',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
});
export const documentIconVisibility = defineFeature({
    type: FeatureType.Boolean,
    propName: 'document_icon_visibility',
    uiName: 'documentIconVisibility',
    displayName: 'Documents',
    description: 'Toggles the display the Documents icon in the header',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const homeButton = defineFeature({
    type: FeatureType.Boolean,
    propName: 'home_button',
    uiName: 'homeButton',
    displayName: 'Home Button',
    description: 'Enable/disable home button in header',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
});
export const homeButtonTopHeader = defineFeature({
    type: FeatureType.Boolean,
    propName: 'home_button_top_header',
    uiName: 'homeButtonTopHeader',
    displayName: 'Home Button Top Header',
    description: 'Enable/Disable the home button in the top header next to documentation',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const homeScreen = defineFeature({
    type: FeatureType.String,
    propName: 'home_screen',
    uiName: 'homeScreen',
    displayName: 'Home Page',
    description: 'Home page for the application',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: 'chat',
    validValues: ['chat', 'workspace', 'analyst-main'],
    isSystem: true,
    flatModelSchema: z.enum(['chat', 'workspace', 'analyst-main']).nullable(),
});
export const chatContextSelector = defineFeature({
    type: FeatureType.Boolean,
    propName: 'chat_context_selector',
    uiName: 'chatContextSelector',
    displayName: 'Chat Context Selector',
    description: 'Enable/Disable the context selector in the chat sidebar header',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const applicationTooltip = defineFeature({
    type: FeatureType.String,
    propName: 'application_tooltip',
    uiName: 'applicationTooltip',
    displayName: 'Application Tooltip',
    description: 'Configure tooltip text that appears on fresh session and on hover for header tiles application icon. Leave empty to disable tooltip',
    category: HeaderTiles,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    flatModelSchema: z.string().nullable(),
});
export const faqIcon = defineFeature({
    type: FeatureType.Boolean,
    propName: 'faq_icon',
    uiName: 'faqIcon',
    displayName: 'FAQ Icon',
    description: 'Enable the FAQ icon in the chat header',
    category: HeaderTiles,
    areas: ['application'],
    surfacedIn: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: false,
    isSystem: true,
});
export const faqChatContextIdentifier = defineFeature({
    type: FeatureType.String,
    propName: 'faq_chat_context_identifier',
    uiName: 'faqChatContextIdentifier',
    displayName: 'FAQ Chat Context Identifier',
    description: "Identifier of the chat context to use as this brand's FAQ. Leave empty to hide the FAQ icon for this brand.",
    category: HeaderTiles,
    areas: ['brand'],
    surfacedIn: ['brand'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
});
export const headerTilesFeatures = [
    chatIconVisibility,
    supportIcon,
    documentIconVisibility,
    homeButton,
    homeButtonTopHeader,
    homeScreen,
    chatContextSelector,
    applicationTooltip,
    faqIcon,
    faqChatContextIdentifier,
];
